const points = [
  {
    icon: "ri-focus-line",
    title: "沉浸式纯净阅读",
    desc: "极简阅读界面，专注每一格分镜，让剧情全情投入不被干扰。",
  },
  {
    icon: "ri-fullscreen-line",
    title: "一键全屏 / 上下翻页",
    desc: "支持竖屏连续滚动与上下翻页，阅读模式随心切换，顺滑流畅。",
  },
  {
    icon: "ri-moon-line",
    title: "夜间阅读模式",
    desc: "自动/手动切换夜间模式，深夜追漫也不刺眼，护眼更舒适。",
  },
  {
    icon: "ri-bookmark-line",
    title: "书签与断点续读",
    desc: "自动记录阅读进度，随时书签收藏，下次打开无缝衔接。",
  },
];

export default function Experience() {
  return (
    <section id="experience" className="relative py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <div className="relative order-2 lg:order-1">
            <div className="overflow-hidden rounded-lg border border-background-600/60">
              <img
                src="https://readdy.ai/api/search-image?query=Reader%20immersed%20in%20reading%20Korean%20manhwa%20on%20a%20tablet%20in%20a%20cozy%20dim%20luxury%20study%20room%2C%20warm%20amber%20desk%20lamp%20glow%2C%20open%20comic%20pages%20and%20coffee%20on%20wooden%20desk%2C%20cinematic%20dark%20ambience%2C%20golden%20tones%2C%20premium%20relaxed%20atmosphere&width=1400&height=1000&seq=experience-read&orientation=landscape"
                alt="尊享无广告韩漫阅读体验"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -bottom-5 -right-3 hidden rounded-lg border border-primary-500/40 bg-background-900/90 px-5 py-4 backdrop-blur sm:block">
              <p className="font-heading text-2xl font-bold text-primary-400">98.6%</p>
              <p className="text-xs text-foreground-300">读者满意度</p>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-400">
              <i className="ri-eye-line"></i>
              阅读体验
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-50 md:text-4xl">
              为<span className="text-gradient-gold">沉浸式追漫</span>
              而生的阅读器
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-400 md:text-base">
              围绕「看得舒服、翻得流畅」打造的高质感阅读器，配合高画质原版资源与无广告环境，让每一话都值得细细品味。
            </p>

            <div className="mt-7 grid gap-4 sm:grid-cols-2">
              {points.map((p) => (
                <div key={p.title} className="rounded-lg border border-background-600/60 bg-background-900/50 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-500/15 text-lg text-secondary-300">
                    <i className={p.icon}></i>
                  </span>
                  <h3 className="mt-3 text-sm font-semibold text-foreground-50">{p.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-400">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}